<template>
    <div class="card">
        <div :id="this.uid" class="map" :style="{ height: this.height + 'px' }"></div>
    </div>
</template>

<script>
    import "leaflet/dist/leaflet.css";
    import L from 'leaflet'

    export default {
        name: 'Map',
        data: () => ({
            map: null,
            marker: null,
        }),
        mounted() {
            this.initMap();
        },
        computed: {
            Clat() {
                if (!this.lat) {
                    return 52.114333
                } else {
                    return this.lat
                }
            },
            Clng() {
                if (!this.lng) {
                    return 19.423667
                } else {
                    return this.lng
                }
            }
        },
        watch: {
            'serviceData': {
                handler:
                    function (val) {
                        this.findLatLng();
                    },
                deep: true
            }
        },
        methods: {
            initMap() {
                this.map = L.map(this.uid).setView([this.Clat, this.Clng], this.zoom);
                var frhot = L.tileLayer(
                    'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
                    {
                        subdomains: 'abc',
                        maxZoom: 18,
                        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OSM</a>',
                    }
                );
                var wiki = L.tileLayer(
                    'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
                    {
                        maxZoom: 18,
                        attribution: '&copy; <a href="https://foundation.wikimedia.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
                    }
                );
                var osm = L.tileLayer(
                    'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                    {
                        maxZoom: 18,
                        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OSM</a>',
                    }
                );
                var baseMaps = {
                    "Hot": frhot,
                    "Wiki": wiki,
                    "OSM": osm,
                };
                wiki.addTo(this.map);

                L.control.layers(baseMaps).addTo(this.map);
                // if(this.message){
                var icon = new L.Icon.Default();
                icon.options.shadowSize = [0, 0];
                this.marker = L.marker([this.Clat, this.Clng], {icon: icon}).addTo(this.map).bindPopup(this.message);
                // }
            },
            findLatLng: _.debounce(function () {
                let address = '';
                if (typeof this.serviceData.code !== 'undefined') {
                    address += this.serviceData.code + ' ';
                }
                if (typeof this.serviceData.city !== 'undefined') {
                    address += this.serviceData.city + ' ';
                }
                if (typeof this.serviceData.street !== 'undefined') {
                    address += this.serviceData.street.replace("/", "-");
                }

                axios.get('https://maps-helper.activemotors.eu/api/lat-lng/' + encodeURIComponent(address))
                    .then((resp) => {
                        if (resp.data.code === 200) {
                            if (resp.data.lat && resp.data.lng) {
                                let newLat = resp.data.lat;
                                let newLng = resp.data.lng;
                                this.serviceData.lat = newLat;
                                this.serviceData.lng = newLng;
                                this.marker.setLatLng(new L.LatLng(newLat, newLng));
                                this.map.setView([newLat, newLng]);
                            }
                        }
                    });
            }, 1500),
        },
        props: {
            lat: {
                default: 52.114333
            },
            lng: {
                default: 19.423667
            },
            zoom: {
                type: Number,
                default: 6
            },
            uid: {
                type: String,
                default: "map"
            },
            height: {
                type: Number,
                default: 600
            },
            message: {
                type: String
            },
            serviceData: {
                default: {},
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Map.vue